import axios from 'axios';
import { confirmedDateLabels, docTypeList } from 'constants/config';

const MODUSIGN_USERNAME = `${process.env.REACT_APP_MODUSIGN_USERNAME}`;
const MODUSIGN_API_KEY = `${process.env.REACT_APP_MODUSIGN_API_KEY}`;

const options = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    authorization: `Basic ${btoa(`${MODUSIGN_USERNAME}:${MODUSIGN_API_KEY}`)}`
  }
};

/**
 * 문서 목록 조회
 * @param {Object} paramInfo 
 */
async function getDocumentsList(paramInfo) {
  const offset = paramInfo.offset;
  const limit = paramInfo.limit;
  const dateRange = paramInfo.dateRange;
  const selectedDocType = paramInfo.selectedDocType;

  let url = `${process.env.REACT_APP_MODUSIGN_BASE_URL}/documents?offset=${offset}&limit=${limit}&filter=`;
  url += encodeURIComponent(`updatedAt ge '${dateRange[0]}' and updatedAt le '${dateRange[1]}'`);

  // 문서타입 선택했을 경우 filter 추가
  if (selectedDocType && selectedDocType !== '0') {
    const filteredType = docTypeList.find((item) => item.value === selectedDocType);

    if (filteredType.label === '양도양수' || filteredType.label === '설치확정서' || filteredType.label === '서비스이용일확정서') {
      url += encodeURIComponent(`and contains(title, '${filteredType.searchKeyword}')`);
    }

    // if (filteredType.label === '양도양수') {
    //   url += encodeURIComponent(`and contains(title, '이전사업자')`);
    // }
    // if (filteredType.label === '설치확정서') {
    //   url += encodeURIComponent(`and contains(title, '설치확정서')`);
    // }
    // if (filteredType.label === '서비스이용일확정서') {
    //   url += encodeURIComponent(`and contains(title, '서비스이용일 확정서')`);
    // }
  }

  // 검색 조건이 여러 개가 추가될 경우 아래 로직 사용 - 모두싸인은 로직이 and 조건만 가능하여 아래 로직 제외
  // if (selectedDocTypeList.length !== docTypeList.length) {
  //   const filteredList = docTypeList.filter((item) => paramInfo.selectedDocTypeList.includes(item.value));
  //   for (let i = 0; i < filteredList.length; i ++) {
  //     if (filteredList[i].label === '양도양수') {
  //       url += encodeURIComponent(`and contains(title, '이전사업자')`);
  //     } 
  //     // TODO 설치확정서 따로 뽑아서 제외 하는 로직 필요 
  //   }
  // }

  try {
    const response = await axios.get(url, options);
    return response.data;
  } catch (error) {
    console.log(error);
  }

}

/**
 * 문서 상세 조회(요청자 입력 조회)
 * @param {string} documentId 
 */
async function getDocument(documentId) {
  let url = `${process.env.REACT_APP_MODUSIGN_BASE_URL}/documents/${documentId}/requester-inputs`;
  try {
    const response = await axios.get(url, options);
    return response.data.requesterInputs;
  } catch (error) {
    console.log(error);
  }
}

/**
 * 문서 목록 조회(전체)
 * @param {Object} elem
 */
async function getDocumentsListAll(elem) {
  let resultArray = [];
  let excludedArray = [];

  if (elem.selectedDocType === undefined || elem.selectedDocType === null) {
    alert('문서 타입이 잘못되었습니다.');
    return;
  }

  const LIMIT_COUNT = 100;
  let offset = 0;
  let totalCount = 0;

  let callCount = 0;

  let paramInfo = {
    limit: LIMIT_COUNT,
    offset: offset,
    dateRange: elem.dateRange,
    selectedDocType: elem.selectedDocType,
  }

  try {
    const firstResponse = await getDocumentsList(paramInfo);

    if (firstResponse.count === 0) {
      return;
    }

    totalCount = firstResponse.count;
    resultArray = [...resultArray, ...firstResponse.documents];
    callCount += firstResponse.documents.length;

    if (elem.selectedDocType === '0') {
      excludedArray = await getDocumentsList({...paramInfo, selectedDocType: '3'});
      excludedArray = excludedArray.documents;
    }

    while (offset < totalCount) {
      offset += LIMIT_COUNT;
      paramInfo = {
        ...paramInfo,
        offset: offset
      }

      const partialResponse = await getDocumentsList(paramInfo);
      if (partialResponse.documents.length > 0) {
        resultArray = [...resultArray, ...partialResponse.documents];
      }
    }
  } catch (error) {
    console.log(error);
  }

  // 전체 선택했을 경우 특정 문서 제외
  if (elem.selectedDocType === '0') {
    let excludedIds = excludedArray.map(item => item.id);
    resultArray = resultArray.filter(item => !excludedIds.includes(item.id));
  }
  
  const resultInfo = {
    dateRange: elem.dateRange,
    resultArray: resultArray
  }

  // url 등 추출
  const extractArray = extractDownloadUrl(resultInfo);
  
  // 각 타입 별 구분
  const distinguishedList = await distinguishDocuments(extractArray);

  const resultData = {
    search_date_range: elem.dateRange,
    document_list: extractArray,
    ... distinguishedList
  }

  return resultData;
}

// download url 추출
const extractDownloadUrl = (resultInfo) => {
  let result = [];

  resultInfo.resultArray.forEach((document) => {
    const splitTitle = document.title.split('_');
    const elem = {
      search_date_range: resultInfo.dateRange,
      id: document.id,
      title: document.title,
      url: document.file.downloadUrl,
      status: document.status,
      updated_at: document.updatedAt,
      record_id: splitTitle[1] ? splitTitle[1] : splitTitle[0],
    }

    result.push(elem);
  });

  return result;
}

// 문서 종류 구분
const distinguishDocuments = async (documentList) => {
  let result = {};
  if (documentList.length === 0) {
    return;
  }

  docTypeList.forEach(({type, searchKeyword, templateType}) => {
    if (!result[`${type}_document_list`]) {
      result[`${type}_document_list`] = {};
    }
    if (type === 'template') {
      // 서비스이용일 확정서
      if (templateType === 'service_date_confirmation') {
        if (!result[`${type}_document_list`]['service_date_confirmation']) {
          result[`${type}_document_list`]['service_date_confirmation'] = [];
        }
        result[`${type}_document_list`]['service_date_confirmation'] = 
        [... result[`${type}_document_list`]['service_date_confirmation'], ...documentList.filter(doc => doc.title.includes(searchKeyword))];

        // result[`${type}_document_list`] = [... result[`${type}_document_list`], ...documentList.filter(doc => doc.title.includes(searchKeyword))];
      } 
    } else {
      result[`${type}_document_list`] = [...documentList];
    }
  });

  // template Id list : 서비스이용일 확정서
  const templateIds = result['template_document_list']['service_date_confirmation'].map(item => item.id);
  
  // 전체 문서에 대한 요청자 입력 조회(label data) - 문서id와 같이 반환
  const templateDataList = await Promise.all(templateIds.map(async id => {
    const data = await getDocument(id);
    return { id, data };
  }));

  // 추출할 라벨명만 데이터 비교 및 추출 - 문서id와 같이 반환
  const matchedDataLists = templateDataList.map(({ id, data }) => {
    return {
      id, 
      data:  data.filter(item => confirmedDateLabels.some(confirmedLabel => confirmedLabel.dataLabel === item.dataLabel))
    };
  });

  // 템플릿 라벨 데이터 반영하여 문서 갱신
  let serviceDocumentList = result['template_document_list']['service_date_confirmation'].map((document) => ({
     ...document, 
     data: matchedDataLists.find(data => data.id === document.id).data
  }));

  result['template_document_list']['service_date_confirmation'] = serviceDocumentList;

  // ocr list
  result['ocr_document_list'] = result['ocr_document_list'].filter((x) => !templateIds.includes(x.id));

  return result;
}


export {
  getDocumentsListAll
};